import { Page } from "@/pages/explorer/types";
import { StreamlitNotebookJobRunsListResponse } from "@/pages/query/types";
import { useState } from "react";
import {
  Card,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Stack,
  Typography,
} from "@altimateai/lego";
import { Graph } from "@/pages/query/Graph";

const PAGE_SIZE_OPTIONS = [
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "200", value: 200 },
  { label: "300", value: 300 },
  { label: "All data", value: 10000 },
];

export const CommonRunsCostChart = ({
  data,
}: {
  data: Page<StreamlitNotebookJobRunsListResponse>;
}) => {
  const [graphSize, setGraphSize] = useState<number>(50);
  if (!data) {
    return null;
  }
  return (
    <Stack direction="column">
      <Stack align="center" justify={"between"}>
        <Typography variant={"section-heading"}>Runs Cost</Typography>
        <div />
        {(data?.total || 0) > PAGE_SIZE_OPTIONS[0].value && (
          <Stack align={"center"} gap={"md"}>
            <Label className={"al-m-0"}>Show Runs:</Label>
            <Select
              defaultValue={PAGE_SIZE_OPTIONS[0].value.toString()}
              onValueChange={value => setGraphSize(parseInt(value, 10))}
            >
              <SelectTrigger className="al-w-[120px]">
                <SelectValue placeholder="Number of runs" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {PAGE_SIZE_OPTIONS.map(option => {
                    return (
                      <SelectItem key={option.value} value={option.value.toString()}>
                        {option.label}
                      </SelectItem>
                    );
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </Stack>
        )}
      </Stack>
      {data && (
        <Card className="al-p-4" aria-label="Runs Cost chart">
          <Graph
            data={data?.items
              ?.slice(0, graphSize)
              .sort(
                (a, b) =>
                  new Date(a.start_time || a.timestamp).getTime() -
                  new Date(b.start_time || b.timestamp).getTime()
              )}
            annotationEnabled
          />
        </Card>
      )}
    </Stack>
  );
};
